import { useContext, useState } from 'react';

import Client from '../../../../../tools/client';
import { ToastContext } from '../../../../../contexts/toast.context';
import { Button, FieldGroup, Input, Label } from '../../../../configuration/sections/configuration-sections.styles';

const client = new Client();

const MailgunIntegrationPanel = ({ integration }) => {
  const [testEmail, setTestEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const { successToast, errorToast } = useContext(ToastContext);

  const handleSendTest = async () => {
    if (!testEmail || !testEmail.includes('@')) {
      errorToast('Enter a valid test email address.');
      return;
    }

    setLoading(true);
    try {
      const res = await client.testIntegrationById(integration.id, { to: testEmail });

      if (res.success) {
        successToast('Test email sent successfully via Mailgun.');
      } else {
        errorToast(`Failed to send test email: ${res.message || 'Unknown error'}`);
      }
    } catch (err) {
      console.error('Mailgun test error:', err);
      errorToast('Error testing Mailgun. Check console for details.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ marginTop: '2rem' }}>
      <FieldGroup>
        <Label htmlFor="mailgun-test-email">Test Email Address</Label>
        <Input
          id="mailgun-test-email"
          type="email"
          value={testEmail}
          onChange={(e) => setTestEmail(e.target.value)}
          placeholder="Enter test email"
        />
      </FieldGroup>

      <Button
        style={{ marginTop: '1rem' }}
        onClick={handleSendTest}
        disabled={!testEmail || loading}
      >
        {loading ? 'Sending...' : 'Send Test Email'}
      </Button>
    </div>
  );
};

export default MailgunIntegrationPanel;